import React from 'react';
import { withRouter } from 'react-router-dom';
import CategoryItemSC, { CategoryHeadlineSC, FaqLinkSC } from './category-item.styled';

const CategoryItem = ({ category, faqs, history }) => {
  const handleFaqClick = (faqId) => {
    history.push(`/faq/detail/${faqId}`);
  };

  return (
    <CategoryItemSC>
      <CategoryHeadlineSC>
        {`0${category.id}. `}
        {category.name}
      </CategoryHeadlineSC>

      {faqs
        .filter((faq) => faq.categoryId === category.id)
        .map((faq) => (
          <FaqLinkSC key={faq.id} onClick={() => handleFaqClick(faq.id)}>
            {faq.question}
          </FaqLinkSC>
        ))}
    </CategoryItemSC>
  );
};

export default withRouter(CategoryItem);
